import { useDispatch, useSelector } from 'react-redux';

import { OperatorField } from './OperatorField';
import { OperatorsActions } from '../../store/reducers/operators';
import Select from '../common/Select';
import {
  PAYMENT_CYCLE_BIWEEKLY,
  PAYMENT_CYCLE_DAILY,
  PAYMENT_CYCLE_MONTHLY,
  PAYMENT_CYCLE_WEEKLY,
  PaymentCycleDisplayName,
} from '../../constants/operators';

const invoiceOptions = [
  { label: PaymentCycleDisplayName.daily, value: PAYMENT_CYCLE_DAILY },
  { label: PaymentCycleDisplayName.weekly, value: PAYMENT_CYCLE_WEEKLY },
  { label: PaymentCycleDisplayName.biweekly, value: PAYMENT_CYCLE_BIWEEKLY },
  { label: PaymentCycleDisplayName.monthly, value: PAYMENT_CYCLE_MONTHLY },
];

export function OperatorPaymentCycle() {
  const dispatch = useDispatch();

  const {
    configuration: { paymentCycle },
  } = useSelector((state) => state.operators);

  const setPaymentCycle = (paymentCycle) => {
    dispatch({ type: OperatorsActions.configuration, payload: { paymentCycle } });
  };

  return (
    <OperatorField
      title="Payment Cycle"
      description="The payout cycle of the operator to issue payments to the seller."
    >
      <Select
        name="payment-cycle"
        value={paymentCycle || ''}
        onChange={(value) => setPaymentCycle(value)}
        options={invoiceOptions}
      />
    </OperatorField>
  );
}
